function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_SEARCH_svg__cls-1",
  d: "M20 7a13 13 0 1013 13A13 13 0 0020 7zm0-7a20 20 0 0116.31 31.58L50.43 45.2l-4.86 5-14.25-13.71A20 20 0 1120 0z"
});

function SvgIconGreySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 50.43 50.24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MC40MyA1MC4yNCI+PGRlZnM+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIwLDdBMTMsMTMsMCwxLDAsMzMsMjAsMTMsMTMsMCwwLDAsMjAsN1ptMC03QTIwLDIwLDAsMCwxLDM2LjMxLDMxLjU4TDUwLjQzLDQ1LjJsLTQuODYsNUwzMS4zMiwzNi40OUEyMCwyMCwwLDEsMSwyMCwwWiIvPjwvc3ZnPg==";
export { SvgIconGreySearch as ReactComponent };